// Pure helpers for the diagram-share invite input.

// Same email shape accepted by the sign-in form.
const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export function isValidInviteEmail(value) {
    return EMAIL_REGEX.test(String(value || '').trim());
}

// True when `value` (case-insensitively) equals the `.email` of any entry in
// `list`. Shared by the member/invite predicates below.
function emailMatches(value, list) {
    const email = String(value || '').trim().toLowerCase();
    if (!email) return false;
    return (list || []).some(
        (x) => x && x.email && String(x.email).toLowerCase() === email
    );
}

// True when `value` is a valid email that already belongs to `members`
// (case-insensitive). Drives the "user is already a member" note.
export function isExistingMember(value, members = []) {
    return isValidInviteEmail(value) && emailMatches(value, members);
}

// True when `value` is a valid email that already has a pending invite
// (case-insensitive). Drives the "user is already invited" note.
export function isPendingInvite(value, pendingInvites = []) {
    return isValidInviteEmail(value) && emailMatches(value, pendingInvites);
}

// True when `value` is a valid email that does NOT already belong to the
// workspace — neither an existing member nor a pending invite (case-insensitive).
// Drives the "will be invited to the workspace" helper line: a pending invite
// already covers the workspace join, so the helper must not show for it.
export function isNewWorkspaceEmail(value, workspaceMembers = [], pendingInvites = []) {
    if (!isValidInviteEmail(value)) return false;
    return !emailMatches(value, workspaceMembers) && !emailMatches(value, pendingInvites);
}
